import React, { useState } from 'react';

import { MenuIcon, XIcon } from 'lucide-react';

import { Button } from '@/components/shadcn/ui/button';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/shadcn/ui/drawer';

import HeaderDrawerBuildInfo from './HeaderDrawerBuildInfo';
import HeaderMenuDrawerDevelopers from './HeaderMenuDrawerDevelopers';
import HeaderMenuDrawerDocs from './HeaderMenuDrawerDocs';
import HeaderMenuDrawerLinks from './HeaderMenuDrawerLinks';
import HeaderMenuDrawerNavigationLinks from './HeaderMenuDrawerNavigationLinks';
import HeaderMenuDrawerSettings from './HeaderMenuDrawerSettings';
// import HeaderMenuDrawerStatistics from './HeaderMenuDrawerStatistics';

const HeaderMenuDrawer: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <Drawer direction="right" open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
      <DrawerTrigger asChild>
        <Button variant="secondary" size="sm" className="rounded-xl p-6 sm:px-4 sm:py-2">
          <MenuIcon className="size-6" />
        </Button>
      </DrawerTrigger>

      <DrawerContent className="flex w-[calc(100vw-16px)] max-w-96 flex-col gap-5 p-3">
        <DrawerTitle hidden>Menu</DrawerTitle>

        <DrawerClose className="mt-2 flex w-full justify-end md:hidden" asChild>
          <div>
            <Button variant="secondary" className="rounded-full">
              <XIcon />
            </Button>
          </div>
        </DrawerClose>

        <DrawerDescription className="flex h-full flex-col items-stretch overflow-y-scroll" asChild>
          <div>
            <div className="md:hidden">
              <HeaderMenuDrawerNavigationLinks />
              <hr className="border-background mx-auto my-4 w-32" />
            </div>

            <div className="flex h-full flex-col justify-start gap-2 text-sm">
              <HeaderMenuDrawerDocs />

              {/*
                Statistics is not visible yet, hidden for now
               <HeaderMenuDrawerStatistics onClick={() => setIsDrawerOpen(false)} /> */}
              <HeaderMenuDrawerDevelopers />
              <HeaderMenuDrawerSettings />
            </div>

            <div className="flex-auto">
              <hr className="border-background mx-auto my-4 w-32" />

              <HeaderMenuDrawerLinks />

              <HeaderDrawerBuildInfo onClick={() => setIsDrawerOpen(false)} />
            </div>
          </div>
        </DrawerDescription>
      </DrawerContent>
    </Drawer>
  );
};

export default HeaderMenuDrawer;
